import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { fuseAnimations } from '@fuse/animations';
import { CoursesAPIService } from '@shared/services/coursesApi.service';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { CurrentHubService } from '@shared/services/currentHub.service';
import { Learnspace } from '@shared/models';
import { CurrentContextService } from '@shared/services/currentContextService';
import { LearnspaceDetailBaseComponent } from '@shared/base-components/learnspace-detail.base.component';
import { AuthenticationService } from '@shared/services/authentication.service';
import { OverlayContainer } from '@angular/cdk/overlay';

@Component({
  selector: 'program-overview',
  templateUrl: './program-overview.component.html',
  styleUrls: ['./program-overview.component.scss'],
  animations: fuseAnimations
})

export class ProgramOverviewComponent extends LearnspaceDetailBaseComponent implements OnChanges {
  @Input() learnspace: Learnspace;

  constructor(
    protected _authservice: AuthenticationService,
    protected _courseApiService: CoursesAPIService,
    protected _CurrentContextService: CurrentContextService,
    protected _dialog: MatDialog,
    protected _route: ActivatedRoute,
    protected _authService: AuthenticationService,
    protected _router: Router,
    protected _overlayContainer: OverlayContainer,
    protected _currentHubService: CurrentHubService
  ) {
    super(_authservice, _courseApiService, _CurrentContextService, _dialog, _route, _authService, _router, _overlayContainer, _currentHubService);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.learnspace) {
      this.setup(this.learnspace);
    }
  }
}
